import { fetchAuthSession } from 'aws-amplify/auth';
import type { Document } from '../App';
import type { EquipmentType } from '../enums';

const getApiEndpoint = () => {
  return 'https://ruaw3fzpy4.execute-api.us-east-1.amazonaws.com/prod';
};

const API_ENDPOINT = getApiEndpoint();

export const ApiService = {
  async getAuthHeaders(): Promise<HeadersInit> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString()
      return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
    } catch (error) {
      console.error('Error getting auth token', error);
      throw new Error('Authentication required');
    }
  },


  async fetchEquipmentModels(equipmentType: EquipmentType): Promise<string[]> {
    const headers = await this.getAuthHeaders();
    const url = `${API_ENDPOINT}/equipment-types/${equipmentType}`;
    
    console.log('Fetching equipment models from:', url);
    
    const response = await fetch(url, { headers });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.models;
  },

  isUuid(value: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(value);
  },


  // Fetch all documents with optional filtering
  async fetchDocuments(model: string): Promise<Document[]> {
    const headers = await this.getAuthHeaders();
        
      const params = new URLSearchParams();
      
      if (model) {
        params.append('model', model);
      }
      
      const queryString = params.toString();
    
    
    const url = `${API_ENDPOINT}/documents${queryString ? `?${queryString}` : ''}`;
    console.log('Fetching documents from:', url);
    
    const response = await fetch(url, { headers });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.documents;
  },

  async fetchDocumentDetails(documentId: string): Promise<Document> {
    const headers = await this.getAuthHeaders();

    let url = ''

    if (this.isUuid(documentId)) {
      url = `${API_ENDPOINT}/documents/${documentId}`;
    } else {
      const [modelId, fileId] = documentId.split('/');
    
      const params = new URLSearchParams();
      
      if (modelId) {
        params.append('model', modelId);
      }
      
      const queryString = params.toString();
      
      // Build the URL with both parameters
      url = `${API_ENDPOINT}/documents/${fileId}?${queryString}`;
    }
        
    console.log('Fetching document details from:', url);
    
    const response = await fetch(url, { headers });
    
    if (!response.ok) {
      console.error(`Failed to fetch document details: ${response.status} ${response.statusText}`);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.document;
  }
};